import { render } from "./NewFarmerPage.vue?vue&type=template&id=3391a3d0&scoped=true"
import script from "./NewFarmerPage.vue?vue&type=script&lang=js"
export * from "./NewFarmerPage.vue?vue&type=script&lang=js"

import "./NewFarmerPage.vue?vue&type=style&index=0&id=3391a3d0&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3391a3d0"]])

export default __exports__